<div
  class="scope-page flex-1 pt-2"
  [class.overflow-auto]="currentTab === ScopeOverviewTab.CONFIGURATION"
  *ngIf="currentScope">
  <scope-ui-tabs
    fontSize="14px"
    (onSelect)="selectTab($event)"
    (onInit)="selectTab($event)"
    [confirm]="confirmTab">
    <scope-ui-tab
      *ngIf="currentScope.isScopeByScenario()"
      requiredSetting="SCOPE_BY_SCENARIO && SCOPE__ENABLE_SCENARIO_PRICING"
      [tabTitle]="ScopeOverviewTab.CONFIGURATION"
      class="scope-tab white-background overflow-auto"
      [active]="route.snapshot.queryParamMap.get('tab') === 'configuration'">
      <ng-container *ngIf="currentTab === ScopeOverviewTab.CONFIGURATION">
        <scope-configuration-cr
          *ngIf="currentChangeRequest; else normalMode"
          [currentScope]="currentScope" />
        <ng-template #normalMode>
          <scope-configuration [currentScope]="currentScope" />
        </ng-template>
      </ng-container>
    </scope-ui-tab>

    <scope-ui-tab
      [tabTitle]="ScopeOverviewTab.SCOPE"
      class="scope-tab white-background"
      [active]="currentTab === ScopeOverviewTab.SCOPE"
      [disabled]="scopeApprovalFlowService.isStateConfigDraft(currentScope.status)"
      [default]="true">
      <router-outlet></router-outlet>
    </scope-ui-tab>

    <scope-ui-tab
      [tabTitle]="ScopeOverviewTab.ACTIVITY"
      [active]="route.snapshot.queryParamMap.get('tab') === 'activity'">
      <scope-activity
        *ngIf="currentTab === ScopeOverviewTab.ACTIVITY"
        [currentUser]="loggedInUser"
        [currentScope]="currentScope"
        [changeRequest]="currentChangeRequest"
        [scopeId]="currentScope.identity.id"
        [cdnConfig]="cdnConfig"
        (onSelectTab)="selectTab($event)" />
    </scope-ui-tab>

    <scope-ui-tab
      requiredSetting="SCOPE__DETAILS"
      [tabTitle]="ScopeOverviewTab.DETAILS"
      [active]="route.snapshot.queryParamMap.get('tab') === 'details'">
      <scope-details-container
        *ngIf="currentTab === ScopeOverviewTab.DETAILS"
        [id]="currentScope.identity.id"></scope-details-container>
    </scope-ui-tab>

    <scope-ui-tab
      [tabTitle]="ScopeOverviewTab.TEAM"
      [active]="route.snapshot.queryParamMap.get('tab') === 'team'">
      <app-team
        *ngIf="currentTab === ScopeOverviewTab.TEAM"
        [loggedInUser]="loggedInUser"
        [currentScope]="currentScope"
        [cdnConfig]="(cdnConfig$ | async)!"
        [companyIntegrations]="companyIntegrations"
        (onShowAddCollaboratorModal)="scopeTeamService.showAddCollaboratorModal(currentScope, cdnConfig)"
        (onShowAddReviewerModal)="scopeTeamService.showAddReviewerModal(currentScope, cdnConfig)"
        (onShowAddApproverModal)="scopeTeamService.showAddApproverModal(currentScope, cdnConfig)"
        (onShowAddTraffickerModal)="scopeTeamService.showAddTraffickerModal(currentScope, cdnConfig)"
        (onUpdateTeamMember)="scopeTeamService.updateTeamMember($event, currentScope)"
        (onDeleteCollaborator)="scopeTeamService.deleteCollaborator($event, currentScope)"
        (onDeleteReviewer)="scopeTeamService.deleteReviewer($event, currentScope)"
        (onDeleteApprover)="scopeTeamService.deleteApprover($event, currentScope)"
        (onDeleteTrafficker)="scopeTeamService.deleteTrafficker($event, currentScope)"></app-team>
    </scope-ui-tab>

    <scope-ui-tab
      [tabTitle]="ScopeOverviewTab.BREAKDOWN"
      [active]="route.snapshot.queryParamMap.get('tab') === 'breakdown'">
      <app-scope-breakdown
        *ngIf="currentTab === ScopeOverviewTab.BREAKDOWN"
        [currentScope]="currentScope"
        [currentRatecard]="rateCard$ | async"></app-scope-breakdown>
    </scope-ui-tab>

    <scope-ui-tab
      [tabTitle]="ScopeOverviewTab.OUTPUT_EDITOR"
      [active]="route.snapshot.queryParamMap.get('tab') === 'output'"
      class="white-background">
      <app-scope-output
        *ngIf="currentTab === ScopeOverviewTab.OUTPUT_EDITOR"
        class="flex flex-col h-full"
        [currentScope]="currentScope"
        [loggedInUser]="loggedInUser"
        [companyDynamicFieldSettings]="companyDynamicFieldSettings"
        [scenarioFields]="scenarioFields"
        (onPreviewExport)="previewExport($event)">
      </app-scope-output>
    </scope-ui-tab>
  </scope-ui-tabs>
</div>
